"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUrl = exports.ERRORS = exports.isValidURL = void 0;
var tslib_1 = require("tslib");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var components = [
    'protocol',
    'hostname',
    'port',
    'pathname',
    'search',
    'hash',
];
var defaultPorts = {
    'http:': '80',
    'https:': '443',
    'ftp:': '21',
    'sftp:': '22',
};
function isValidURL(str) {
    return /^(((ftp|sftp|http|https):)?\/\/)?[a-zа-я0-9]+([-.]{1}[a-zа-я0-9]+)*\.[a-zа-я]{2,10}(:[0-9]{1,5})?(\/.*)?$/i.test(str);
}
exports.isValidURL = isValidURL;
exports.ERRORS = {
    invalidURL: '[URL] Could not parse url',
    invalidPort: '[URL] Port should be a convertible to Number value',
    invalidParamName: '[URL] Invalid parameter name',
};
exports.parseUrl = (function () {
    if (global.URL) {
        return function (url) {
            return lodash_1.default.pick(new global.URL(url, document.location), components);
        };
    }
    var aElement = document.createElement('a');
    return function (url) {
        aElement.href = url;
        return lodash_1.default.pick(aElement, components);
    };
})();
var URL = /** @class */ (function () {
    function URL(url, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        this._map = {}; // will be filled in constructor
        var _a = options.skipValidation, skipValidation = _a === void 0 ? false : _a;
        if (!skipValidation && !isValidURL(url)) {
            throw new Error(exports.ERRORS.invalidURL);
        }
        var parts = (0, exports.parseUrl)(url);
        lodash_1.default.forEach(parts, function (value, key) {
            _this[key] = value;
        });
    }
    Object.defineProperty(URL.prototype, "protocol", {
        get: function () {
            return this._map.protocol;
        },
        set: function (val) {
            if (lodash_1.default.isNil(val) || val === '') {
                this._map.protocol = '';
            }
            else {
                this._map.protocol = lodash_1.default.includes(val, ':') ? val : "".concat(val, ":");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "domain", {
        get: function () {
            return this._map.hostname;
        },
        set: function (val) {
            if (lodash_1.default.isNil(val) || val === '') {
                this._map.hostname = '';
            }
            else if (lodash_1.default.isArray(val)) {
                this._map.hostname = val.join('.');
            }
            else {
                this._map.hostname = "".concat(val);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "hostname", {
        get: function () {
            return this.domain;
        },
        set: function (val) {
            this.domain = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "port", {
        get: function () {
            var port = this._map.port;
            var protocol = this.protocol;
            if (port === defaultPorts[protocol]) {
                return '';
            }
            return port;
        },
        set: function (val) {
            if (lodash_1.default.isNil(val) || val === '') {
                this._map.port = '';
            }
            else {
                if (!/^\d+$/.test(val)) {
                    throw new Error(exports.ERRORS.invalidPort);
                }
                this._map.port = String(val);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "path", {
        get: function () {
            return this._map.pathname;
        },
        set: function (val) {
            if (lodash_1.default.isNil(val) || val === '') {
                this._map.pathname = '';
            }
            else if (lodash_1.default.isArray(val)) {
                this._map.pathname = "/".concat(val.join('/'));
            }
            else {
                this._map.pathname = lodash_1.default.startsWith(val, '/')
                    ? String(val)
                    : "/".concat(val);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "pathname", {
        get: function () {
            return this.path;
        },
        set: function (val) {
            this.path = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "search", {
        get: function () {
            return this._map.search;
        },
        set: function (val) {
            if (lodash_1.default.isNil(val) || val === '') {
                this._map.search = '';
            }
            else if (lodash_1.default.isString(val) && val.length) {
                this._map.search = lodash_1.default.includes(val, '?') ? val : "?".concat(val);
            }
            else if (lodash_1.default.isNumber(val)) {
                this._map.search = "?".concat(val);
            }
            else {
                var keys = lodash_1.default.keys(val);
                if (keys.length) {
                    this._map.search = "?".concat(lodash_1.default.map(keys, function (key) { return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(val[key])); }).join('&'));
                }
                else {
                    this._map.search = '';
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "hash", {
        get: function () {
            return this._map.hash;
        },
        set: function (val) {
            if (lodash_1.default.isNil(val) || val === '') {
                this._map.hash = '';
            }
            else {
                this._map.hash = lodash_1.default.includes(val, '#') ? val : "#".concat(val);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "filename", {
        get: function () {
            return this.path.split('/').pop();
        },
        set: function (val) {
            var pathArray = this.path.split('/').slice(1, -1);
            if (!(lodash_1.default.isNil(val) || val === '')) {
                pathArray.push(val);
            }
            this.path = pathArray;
        },
        enumerable: false,
        configurable: true
    });
    URL.prototype.addParam = function (name, value) {
        if (value === void 0) { value = ''; }
        if (!name) {
            throw new Error(exports.ERRORS.invalidParamName);
        }
        var params = this._parseSearch(this.search);
        params[name] = value;
        this.search = params;
    };
    URL.prototype.removeParam = function (name) {
        if (!name) {
            throw new Error(exports.ERRORS.invalidParamName);
        }
        var params = this._parseSearch(this.search);
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete params[name];
        this.search = params;
    };
    URL.prototype.hasParam = function (name) {
        return !lodash_1.default.isNil(this.getParam(name));
    };
    URL.prototype.getParam = function (name) {
        var params = this._parseSearch(this.search);
        return params[name];
    };
    URL.prototype._parseSearch = function (searchString) {
        var params = {};
        searchString = searchString.replace('?', '');
        if (!searchString.length) {
            return params;
        }
        var parts = searchString.split('&');
        lodash_1.default.forEach(parts, function (part) {
            var _a = tslib_1.__read(part.split('='), 2), name = _a[0], _b = _a[1], value = _b === void 0 ? '' : _b;
            params[decodeURIComponent(name)] = decodeURIComponent(value);
        });
        return params;
    };
    Object.defineProperty(URL.prototype, "href", {
        get: function () {
            var port = this.port ? ":".concat(this.port) : '';
            return "".concat(this.protocol, "//").concat(this.domain).concat(port).concat(this.path).concat(this.search).concat(this.hash);
        },
        enumerable: false,
        configurable: true
    });
    URL.prototype.toString = function () {
        return this.href;
    };
    return URL;
}());
exports.default = URL;
//# sourceMappingURL=index.js.map